export default __webpack_public_path__ + "static/media/2-formacao.2edcb0bd.svg";